import {PRETTO_BASE_URL, PRETTO_UTM_PARAMS, PrettoMaturityKind, PrettoUtmContext} from "@/app/constants/prettoJourney"

export function appendPrettoUtmContext(params: URLSearchParams, utm?: PrettoUtmContext): void {
    if (utm?.content) params.set("utm_content", utm.content)
    if (utm?.term) params.set("utm_term", utm.term)
}

export function buildPrettoMaturityUrl(
    maturityStatus: string,
    kind: PrettoMaturityKind,
    utm: PrettoUtmContext,
    gclid?: string | null,
    userToken?: string | null,
): string {
    const params = new URLSearchParams({maturityStatus, kind, ...PRETTO_UTM_PARAMS})
    appendPrettoUtmContext(params, utm)
    if (gclid) params.set("gclid", gclid)
    if (userToken) params.set("user_token", userToken)
    return `${PRETTO_BASE_URL}?${params.toString()}`
}
